module.exports = __webpack_public_path__ + "img/support_b5.15235bb3.png";